import { Component, Input } from "@angular/core";

@Component({
  selector: "app-sidebar-icon",
  template: `
    <svg
      [attr.width]="size"
      [attr.height]="size"
      viewBox="0 0 24 24"
      fill="none"
      [ngSwitch]="name"
      class="sb-svg"
    >
      <ng-container *ngSwitchCase="'dashboard'">
        <path d="M3 13l2-2 4 4 8-8 4 4M3 21h18"
          stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'wrench'">
        <path d="M14.7 6.3a4 4 0 105.66 5.66L18 14.5l-7.5 7.5-3-3L15 11.5l2.54-2.54a4 4 0 00-2.84-2.66z"
          stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'inventory'">
        <path d="M3 7l9-4 9 4M3 7v10l9 4 9-4V7M3 7l9 4m9-4l-9 4m0 0v10"
          stroke="currentColor" stroke-width="1.8"
          stroke-linejoin="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'calendar'">
        <rect x="3" y="5" width="18" height="16" rx="2"
          stroke="currentColor" stroke-width="1.8"/>
        <path d="M3 10h18M8 3v4M16 3v4"
          stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'receipt'">
        <path d="M5 3h14v18l-3-2-2 2-2-2-2 2-2-2-3 2V3z"
          stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
        <path d="M9 8h6M9 12h6M9 16h4"
          stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'cash'">
        <rect x="2" y="6" width="20" height="12" rx="2"
          stroke="currentColor" stroke-width="1.8"/>
        <circle cx="12" cy="12" r="2.5"
          stroke="currentColor" stroke-width="1.8"/>
      </ng-container>

      <ng-container *ngSwitchCase="'pay'">
        <path d="M12 1v22M5 8h11a3 3 0 010 6H8a3 3 0 000 6h11"
          stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'bank'">
        <path d="M3 21h18M3 10h18M5 21V10M19 21V10M9 21V10M15 21V10M12 3l9 5H3l9-5z"
          stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'book'">
        <path d="M4 4a2 2 0 012-2h13v18H6a2 2 0 00-2 2V4zM4 18a2 2 0 002-2h13"
          stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'file-text'">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
          stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 2v6h6M8 13h8M8 17h6"
          stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'shield'">
        <path d="M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-4z"
          stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'chart'">
        <path d="M3 3v18h18M7 14l4-4 4 4 5-7"
          stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'cog'">
        <circle cx="12" cy="12" r="3"
          stroke="currentColor" stroke-width="1.8"/>
        <path d="M19.4 15a1.7 1.7 0 00.34 1.87l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.7 1.7 0 00-1.87-.34 1.7 1.7 0 00-1.04 1.56V21a2 2 0 01-4 0v-.08a1.7 1.7 0 00-1.13-1.56 1.7 1.7 0 00-1.87.34l-.06.06A2 2 0 014.04 16.94l.06-.06a1.7 1.7 0 00.34-1.87 1.7 1.7 0 00-1.56-1.04H3a2 2 0 010-4h.08A1.7 1.7 0 004.6 9a1.7 1.7 0 00-.34-1.87l-.06-.06a2 2 0 012.83-2.83l.06.06a1.7 1.7 0 001.87.34H9a1.7 1.7 0 001.04-1.56V3a2 2 0 014 0v.08A1.7 1.7 0 0015.04 4.6a1.7 1.7 0 001.87-.34l.06-.06a2 2 0 012.83 2.83l-.06.06A1.7 1.7 0 0019.4 9a1.7 1.7 0 001.56 1.04H21a2 2 0 010 4h-.08A1.7 1.7 0 0019.4 15z"
          stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'search'">
        <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/>
        <path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'chev-right'">
        <path d="M9 6l6 6-6 6"
          stroke="currentColor" stroke-width="2.2"
          stroke-linecap="round" stroke-linejoin="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'chev-down'">
        <path d="M6 9l6 6 6-6"
          stroke="currentColor" stroke-width="2.2"
          stroke-linecap="round" stroke-linejoin="round"/>
      </ng-container>

      <ng-container *ngSwitchCase="'sidebar'">
        <rect x="3" y="4" width="18" height="16" rx="2"
          stroke="currentColor" stroke-width="1.8"/>
        <path d="M9 4v16" stroke="currentColor" stroke-width="1.8"/>
      </ng-container>

      <ng-container *ngSwitchCase="'logo-s'">
        <path d="M16.8 6.6c0 0-1.8-1.8-4.8-1.8-3.6 0-6 2.4-6 4.8 0 4.2 10.8 2.4 10.8 6.6 0 2.76-2.4 4.2-5.4 4.2-3 0-5.4-1.8-5.4-1.8"
          stroke="white" stroke-width="2.2" stroke-linecap="round" fill="none"/>
      </ng-container>

      <ng-container *ngSwitchCase="'power'">
        <path d="M12 3v8M5.6 7.6a8 8 0 1012.8 0"
          stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </ng-container>
    </svg>
  `,
  styles: [
    `:host { display: inline-flex; align-items: center; justify-content: center; line-height: 0; }
     .sb-svg { display: block; }`,
  ],
})
export class SidebarIconComponent {
  @Input() name: string;
  @Input() size: number = 17;
}
